/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LogEntry } from './LogEntry';
import {
    LogEntryFromJSON,
    LogEntryFromJSONTyped,
    LogEntryToJSON,
    LogEntryToJSONTyped,
} from './LogEntry';

/**
 * 
 * @export
 * @interface IPAddress
 */
export interface IPAddress {
    /**
     * 
     * @type {number}
     * @memberof IPAddress
     */
    readonly id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof IPAddress
     */
    readonly tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    readonly technologies: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    readonly findingsStats: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    readonly ports: string;
    /**
     * 
     * @type {Array<LogEntry>}
     * @memberof IPAddress
     */
    readonly history: Array<LogEntry>;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    riskScore?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IPAddress
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPAddress
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    ipAddress: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    org?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    asn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    cdn?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    cdnName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IPAddress
     */
    waf?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    wafName?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    loc?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    postal?: string;
    /**
     * 
     * @type {string}
     * @memberof IPAddress
     */
    timezone?: string;
    /**
     * 
     * @type {number}
     * @memberof IPAddress
     */
    team: number;
}

/**
 * Check if a given object implements the IPAddress interface.
 */
export function instanceOfIPAddress(value: object): value is IPAddress {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tags' in value) || value['tags'] === undefined) return false;
    if (!('technologies' in value) || value['technologies'] === undefined) return false;
    if (!('findingsStats' in value) || value['findingsStats'] === undefined) return false;
    if (!('ports' in value) || value['ports'] === undefined) return false;
    if (!('history' in value) || value['history'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('ipAddress' in value) || value['ipAddress'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    return true;
}

export function IPAddressFromJSON(json: any): IPAddress {
    return IPAddressFromJSONTyped(json, false);
}

export function IPAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tags': json['tags'],
        'technologies': json['technologies'],
        'findingsStats': json['findings_stats'],
        'ports': json['ports'],
        'history': ((json['history'] as Array<any>).map(LogEntryFromJSON)),
        'riskScore': json['risk_score'] == null ? undefined : json['risk_score'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'ipAddress': json['ip_address'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'country': json['country'] == null ? undefined : json['country'],
        'org': json['org'] == null ? undefined : json['org'],
        'asn': json['asn'] == null ? undefined : json['asn'],
        'cdn': json['cdn'] == null ? undefined : json['cdn'],
        'cdnName': json['cdn_name'] == null ? undefined : json['cdn_name'],
        'waf': json['waf'] == null ? undefined : json['waf'],
        'wafName': json['waf_name'] == null ? undefined : json['waf_name'],
        'city': json['city'] == null ? undefined : json['city'],
        'region': json['region'] == null ? undefined : json['region'],
        'loc': json['loc'] == null ? undefined : json['loc'],
        'postal': json['postal'] == null ? undefined : json['postal'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'team': json['team'],
    };
}

  export function IPAddressToJSON(json: any): IPAddress {
      return IPAddressToJSONTyped(json, false);
  }

  export function IPAddressToJSONTyped(value?: Omit<IPAddress, 'id'|'tags'|'technologies'|'findings_stats'|'ports'|'history'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'risk_score': value['riskScore'],
        'is_active': value['isActive'],
        'ip_address': value['ipAddress'],
        'hostname': value['hostname'],
        'country': value['country'],
        'org': value['org'],
        'asn': value['asn'],
        'cdn': value['cdn'],
        'cdn_name': value['cdnName'],
        'waf': value['waf'],
        'waf_name': value['wafName'],
        'city': value['city'],
        'region': value['region'],
        'loc': value['loc'],
        'postal': value['postal'],
        'timezone': value['timezone'],
        'team': value['team'],
    };
}

